<template>
    <div>
        <div class="nav">
            <Header/>
        </div>
        <div class="app-width main-height" style="margin-bottom: 30px">
            <header class="tabs">
                <div class="tab"
                     @click.stop="handleTabClick('currentQuestion')"
                     :class="{'is--active': activeHeader === 'currentQuestion'}">当前问卷</div>
                <div class="tab"
                     @click.stop="handleTabClick('myQuestion')"
                     :class="{'is--active': activeHeader === 'myQuestion'}">我的问卷</div>
            </header>
            <keep-alive>
                <component :is="activeHeader"/>
            </keep-alive>
        </div>
        <bottomnav/>
    </div>
</template>

<script>
import Header from "@/components/header";
import currentQuestion from "./cpns/currentQuestion";
import myQuestion from "./cpns/myQuestion";
import bottomnav from "@/components/bottomnav";
export default {
    name: "PSQ",
    data () {
        return {
            activeHeader: "currentQuestion",
            questionList: []
        }
    },
    components: {
        Header,
        myQuestion,
        currentQuestion,
        bottomnav
    },
    methods: {
        handleTabClick (value) {
            this.activeHeader = value
        }
    }
}
</script>

<style scoped lang="less">
.main-height {
    min-height: calc(100vh - 100px - 200px);
}
::v-deep .question-list {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-template-rows: auto;
    // 间隙
    grid-gap: 30px;
}
.nav {
    height: 70px;
}
.tabs {
    display: flex;
    .tab {
        padding: 20px;
        font-size: 18px;
        color: #868EA1;
        cursor: pointer;
        &.is--active {
            color: #2F3134;
        }
    }
}

</style>
